/**
 * TNK-132 — eBay Integration moved to /settings/ebay because it's
 * connection + tokens + sync prefs (a setting, not a tool). Thin
 * redirect kept here so existing bookmarks + the navbar's muscle
 * memory still land correctly.
 */
import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";

export const Route = createFileRoute("/tools/ebay")({
  component: EbayMovedRedirect,
});

function EbayMovedRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    void navigate({ to: "/settings/ebay", replace: true });
  }, [navigate]);
  return (
    <div className="mx-auto max-w-md py-12 text-center text-muted-foreground">
      <Loader2 size={20} className="mx-auto animate-spin" />
      <p className="mt-3 text-sm">Moved to Settings → eBay…</p>
    </div>
  );
}
